<ion-item>
  <ion-label>Contact:</ion-label>
  <ionic-selectable [ngModel]="sender()"
                    (ngModelChange)="sender.set($event)"
                    [items]="contacts()"
                    itemValueField="uniqueId"
                    itemTextField="FULLNAME"
                    placeholder="Select Contact"
                    [hasVirtualScroll]="true"
                    [virtualScrollHeaderFn]="contactHeader"
                    [canSearch]="true"
  >
    <ng-template ionicSelectableItemTemplate let-port="item" let-isPortSelected="isItemSelected">
      {{ port.FULLNAME }} ({{ port.PHONE }})
    </ng-template>
  </ionic-selectable>
</ion-item>
